import Container from '@/components/atoms/Container'
import { useLoadMore } from '@/hooks/useLoadMore'
import creditsService from '@/services/creditsService'
import profileAwariService from '@/services/profileAwariService'
import { CreditsModel } from '@models'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { twMerge } from 'tailwind-merge'

export function Historic() {
	const { data: dataProfileAwari } = profileAwariService.getProfileAwari()

	const { data, isLoading } = creditsService.list()

	const { currentItens, maxItens, setPage, paginatedItens } =
		useLoadMore<CreditsModel.Show>(data?.credits || [])

	return (
		<Container className='pt-4 pb-10'>
			<div className='flex flex-col gap-12'>
				<div className='flex flex-col gap-3'>
					<div className='flex items-center gap-4'>
						<img
							src='/imgs/admin/awari-coin.png'
							alt='Emoji'
							className='w-[28px] h-[28px] hidden md:flex'
						/>
						<h2 className='text-xl md:text-[26px] text-white overflow-clip break-words'>
							{dataProfileAwari && dataProfileAwari?.balance > 0
								? `Você possui ${dataProfileAwari?.balance.toLocaleString('pt-BR')} Créditos`
								: 'Você não possui nenhum crédito'}
						</h2>
					</div>
					<h3 className='font-normal text-base text-white/70 max-w-[600px]'>
						Você pode agendar sessões de mentoria, participar de turmas com
						aulas ao vivo e acessar todos os materiais de nossos cursos.
					</h3>
				</div>
				<div className='flex z-10 flex-col p-5 md:p-8 md:px-10 gap-10 border border-white/10 shadow-course rounded-md bg-zinc-900 w-full max-w-[600px]'>
					<div className='flex flex-col gap-0'>
						<h4 className='text-xl text-white leading-[140%] font-medium'>
							Histórico de utilizações
						</h4>
						<p className='text-base text-white/70 leading-[155%]'>
							Veja onde você gastou seus créditos
						</p>
					</div>
					<div>
						<div className='w-full flex flex-col md:hidden'>
							{(() => {
								if (isLoading) return <></>

								if (data) {
									return (
										<ul className='flex flex-col gap-6'>
											{paginatedItens?.map(
												({ action, category, value, date }, key) => {
													const signal = action === 'IN' ? '+' : '-'

													return (
														<li
															className='flex flex-col text-xs font-medium leading-[140%] text-white/70 gap-3'
															key={key}
														>
															<p
																className={twMerge(
																	'relative before:mt-[1px] before:content-[""] before:h-5/6 before:w-[2px] before:absolute before:bg-green',
																	classNames({
																		'before:bg-red': signal === '-',
																	})
																)}
															>
																<span className='ml-2'>{category}</span>
															</p>
															<p
																className={twMerge(
																	'text-green',
																	classNames({
																		'text-red': signal === '-',
																	})
																)}
															>
																{signal} ({value}) créditos
															</p>
															<p className='text-white'>
																{dayjs(date)
																	.locale('pt-br')
																	.format('DD/MM/YYYY')}
															</p>
														</li>
													)
												}
											)}
										</ul>
									)
								}

								return (
									<>
										<thead>
											<tr className='text-base leading-[140%] text-white font-medium'>
												<th align='left'>Categoria</th>
												<th align='left'>Quantidade</th>
												<th align='right'>Data</th>
											</tr>
										</thead>
										<tbody>
											<tr className='text-xs font-medium items-center justify-center leading-[140%] text-white/70'>
												<td className='py-5 text-center w-[52.5%]'>
													<p className='w-1/3'>-</p>
												</td>
												<td className='py-5 text-center'>
													<p className='w-1/3'>-</p>
												</td>
												<td
													className='py-5 w-full inline-flex text-start justify-end items-end'
													align='right'
												>
													<p className='w-1/5'>-</p>
												</td>
											</tr>
										</tbody>
									</>
								)
							})()}
						</div>
						<table className='w-full hidden md:table'>
							{(() => {
								if (isLoading) return <></>

								if (data) {
									return (
										<>
											<thead>
												<tr className='text-base leading-[140%] text-white font-medium'>
													<th align='left'>Categoria</th>
													<th align='left'>Quantidade</th>
													<th align='center'>Data</th>
												</tr>
											</thead>
											<tbody>
												{paginatedItens?.map(
													({ action, category, value, date }, key) => {
														const signal = action === 'IN' ? '+' : '-'

														return (
															<tr
																className='text-xs leading-[140%] text-white border-b border-b-gray-100 last-of-type:border-none dark:border-opacity-10'
																key={key}
															>
																<td className='py-5 font-medium'>
																	<span
																		className={twMerge(
																			'relative before:mt-[1px] before:content-[""] before:-ml-2 before:h-5/6 before:w-[2px] before:absolute before:bg-green pl-2',
																			classNames({
																				'before:bg-red': signal === '-',
																			})
																		)}
																	>
																		{category}
																	</span>
																</td>
																<td
																	className={twMerge(
																		'py-5 font-semibold text-green',
																		classNames({
																			'text-red': signal === '-',
																		})
																	)}
																>
																	{signal} ({value}) créditos
																</td>
																<td className='py-5 text-white' align='center'>
																	{dayjs(date)
																		.locale('pt-br')
																		.format('DD/MM/YYYY')}
																</td>
															</tr>
														)
													}
												)}
											</tbody>
										</>
									)
								}

								return (
									<>
										<thead>
											<tr className='text-base leading-[140%] text-white font-medium'>
												<th align='left'>Categoria</th>
												<th align='left'>Quantidade</th>
												<th align='right'>Data</th>
											</tr>
										</thead>
										<tbody>
											<tr className='text-xs font-medium items-center justify-center leading-[140%] text-white/70'>
												<td className='py-5 text-center w-[52.5%]'>
													<p className='w-1/3'>-</p>
												</td>
												<td className='py-5 text-center'>
													<p className='w-1/3'>-</p>
												</td>
												<td
													className='py-5 w-full inline-flex text-start justify-end items-end'
													align='right'
												>
													<p className='w-1/5'>-</p>
												</td>
											</tr>
										</tbody>
									</>
								)
							})()}
						</table>
					</div>
				</div>
				{data && data?.credits?.length > 5 && (
					<div className='flex flex-col gap-2'>
						<div className='flex'>
							<p className='text-sm font-medium text-white/70 leading-[155%]'>
								Vendo {currentItens} de {maxItens} registros.
							</p>
						</div>
						<div className='flex'>
							{(() => {
								if (currentItens !== maxItens) {
									return (
										<button
											type='button'
											onClick={() => {
												setPage((current) => current + 1)
											}}
											className='text-sm font-bold leading-[155%] text-brand-primary'
										>
											Carregar mais
										</button>
									)
								}
							})()}
						</div>
					</div>
				)}
			</div>
		</Container>
	)
}
